import { Routes } from '@angular/router';
import { groupsRoute } from './groups.route';
import { AuthenticationRoute } from '../../authentication.route';
import { RouteSubComponent } from 'authorization';
import { RouteLazyComponent } from 'authorization';

export const groupsRouting: Routes = [
  {
    path: 'dashboard',
    data: {
      breadcrumb: {
        skip: true,
      },
      title: '',
    },
    loadComponent: () =>
      import(
        'src/domains/theme/app/component/full-layout/full-layout.component'
      ).then((c) => c.FullLayoutComponent),
    children: [
      {
        path: 'groups_list',
        loadComponent: () =>
          import('./app/component/groups-list/groups-list.component').then(
            (c) => c.GroupsListComponent,
          ),
        data: {
          breadcrumb: {
            skip: true,
          },
        },
      } as RouteSubComponent<typeof groupsRoute.map.dashboard, 'groups_list'>,
      {
        path: 'create_group',
        loadComponent: () =>
          import('./app/component/create-group/create-group.component').then(
            (m) => m.CreateGroupComponent,
          ),
        data: {
          breadcrumb: {
            label: 'اضافه کردن گروه',
            parent: ['گروه ها'],
            parentUrl: [AuthenticationRoute.map.groups.dashboard.groups_list],
          },
          title: '',
        },
      } as RouteSubComponent<typeof groupsRoute.map.dashboard, 'create_group'>,
      {
        path: 'edit_group',
        loadComponent: () =>
          import('./app/component/edit-groups/edit-groups.component').then(
            (m) => m.EditGroupsComponent,
          ),
        data: {
          breadcrumb: {
            label: 'ویرایش گروه',
            parent: ['گروه ها'],
            parentUrl: [AuthenticationRoute.map.groups.dashboard.groups_list],
          },
          title: '',
        },
      } as RouteSubComponent<typeof groupsRoute.map.dashboard, 'edit_group'>,
    ],
  } as RouteLazyComponent<typeof groupsRoute.map, 'dashboard'>,
];
